// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00fcaaa7","667":"18919e15","977":"d0151ab7"}[chunkId] + ".chunk.js";
};